// DEV-4977/MC-12: client for the per-loan loan-concession maker-checker queue. Targets
// Skynet.Pricing's LoanConcessionRequestController (Source/WebApi/.../LoanConcessionRequestController.cs,
// route `loan-concession-requests`): the pending queue is GET `/pending`, and each decision is
// POST `/{id}/approve` | `/{id}/reject` (server enforces requester != approver + budget cap). Every call
// skips the global forbidden-reload: the GET degrades to an empty queue, and the decision WRITES surface
// a 403 (or the duplicate-open-request 409) inline via the thunk mutation-error slice instead of
// triggering the page-reload interceptor.
import { SKIP_FORBIDDEN } from './httpConfig';

export class MarginConcessionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConcessions() {
    return this.#http.get('/api/loan-concession-requests/pending', SKIP_FORBIDDEN);
  }

  async approve(concessionRequestId, note) {
    return this.#http.post(
      `/api/loan-concession-requests/${concessionRequestId}/approve`,
      { note: note ?? null },
      SKIP_FORBIDDEN,
    );
  }

  async reject(concessionRequestId, note) {
    return this.#http.post(
      `/api/loan-concession-requests/${concessionRequestId}/reject`,
      { note: note ?? '' },
      SKIP_FORBIDDEN,
    );
  }
}
